import noop from 'lodash/fp/noop';

import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { UINT_8, createSysParamNumericTypesOptions } from '~/features/sysParams/constants/numericTypes';
import SysParamDefinitionNumericValueForm
    from '~/features/sysParams/components/SysParamDefinitionNumericValueForm';
import { selectionByValue } from '~/features/base/utils/selectUtils';
import Select from '@rio-cloud/rio-uikit/Select';
import NumberInput from '@rio-cloud/rio-uikit/NumberInput';

/**
 * System parameter definition editor form.
 */
export class SysParamDefinitionNumericEditorForm extends PureComponent {

    constructor(props) {
        super(props);
        this.onNumericTypeSelect = this.onNumericTypeSelect.bind(this);
        this.onNumericMinValueChange = this.onNumericMinValueChange.bind(this);
        this.onNumericMaxValueChange = this.onNumericMaxValueChange.bind(this);
        this.onDefaultValueChange = this.onDefaultValueChange.bind(this);
    }

    onNumericTypeSelect(numericType) {
        const key = numericType.value;
        this.props.changeSysParamDefinitionEditor({
            numericType: key,
        });
    }

    onNumericMinValueChange(value) {
        this.props.changeSysParamDefinitionEditor({
            numericMinValue: value,
        });
    }

    onNumericMaxValueChange(value) {
        this.props.changeSysParamDefinitionEditor({
            numericMaxValue: value,
        });
    }

    onDefaultValueChange(value) {
        this.props.changeSysParamDefinitionEditor({
            numericDefaultValue: value,
        });
    }

    render() {
        const model = this.props.model;
        const numericType = model.numericType || UINT_8;
        const optionsWithSelection = selectionByValue(numericType)(createSysParamNumericTypesOptions());
        // TODO Too much knowledge about model
        const defaultValue = this.renderDefaultValue(model);
        return (
            <div>
                <div className='form-group form-group-numeric-type'>
                    <label className='control-label'>
                        <FormattedMessage id='intl-msg:type' />
                    </label>
                    <Select options={optionsWithSelection}
                        onChange={this.onNumericTypeSelect} />
                </div>
                <div className='form-group form-group-numeric-min-value'>
                    <label className='control-label'>
                        <FormattedMessage id='intl-msg:minValue' />
                    </label>
                    <NumberInput min={0} value={parseInt(model.numericMinValue, 10)}
                        onChange={value => this.onNumericMinValueChange(value)}/>
                </div>
                <div className='form-group form-group-numeric-max-value'>
                    <label className='control-label'>
                        <FormattedMessage id='intl-msg:maxValue' />
                    </label>
                    <NumberInput min={0} value={parseInt(model.numericMaxValue, 10)}
                        onChange={value => this.onNumericMaxValueChange(value)}/>
                </div>
                {defaultValue}
            </div>
        );
    }

    renderDefaultValue(model) {
        if (model.hasDefault) {
            return (
                <SysParamDefinitionNumericValueForm
                    label={'intl-msg:defaultValue'}
                    min={parseInt(model.numericMinValue, 10)}
                    max={parseInt(model.numericMaxValue, 10)}
                    value={parseInt(model.numericDefaultValue, 10)}
                    onChange={this.onDefaultValueChange.bind(this)}/>
            );
        }
    }
}

export default SysParamDefinitionNumericEditorForm;

SysParamDefinitionNumericEditorForm.defaultProps = {
    model: {},
    changeSysParamDefinitionEditor: noop,
};

SysParamDefinitionNumericEditorForm.propTypes = {
    // props
    model: PropTypes.object,
    // functions
    changeSysParamDefinitionEditor: PropTypes.func,
};
